<template>
      <div id="home-content">
            <section id="home-hero" class="section">
                  <div class="grid-container">
                        <div class="grid-x grid-padding-x">
                              <div class="cell medium-12 large-5">
                                    <h1 class="mt32"><span>{{sloganIn}}—<br class="break"/>more care options<br class="break"/></span> for lower costs</h1>
                                    <p class="content">{{sloganIn}} is a new type of health<br class="break"/> plan that gives you access to convenient, high-<br class="break"/>quality care at lower costs.  </p>
                                    <p class="font-orange">Check to see if your doctor is in the Link network. </p>
                                    <!--<p class="video-btn">
                                          <a @click="openVideo()"><img src="img/anthem-play-icon.png" width="36"/> <span>Watch our video</span></a>
                                    </p>-->
                                    <div class="grid-x grid-padding-x align-btn-center">
                                          <div class="cell small-5">
                                                <router-link to="/evaluation" class="button warning anthem-btn expanded">Check Now</router-link>
                                          </div>
                                          <div class="cell small-5 video-cta">
                                                <a @click="openVideo()" class="button hollow mb0 expanded" target="_blank" v-smooth-scroll>Watch our video</a>
                                          </div>
                                    </div>
                              </div>
                              <div class="cell large-7 video-img-cta">
                                   <div style="position: relative; display: block; max-width: 960px;">
                                          <div style="padding-top: 56.25%;">
                                                <iframe src="https://players.brightcove.net/3639471564001/default_default/index.html?videoId=6279080304001" allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"  frameborder="0" allowfullscreen></iframe>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section id="main-content" class="section">
                  <div class="main-content-features">
                        <div class="grid-container">
                              <div class="grid-x grid-padding-x mb96">
                                    <div class="cell large-4">
                                          <img src="img/save-time.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>Save time and money with an innovative health plan</h3> 
                                          <p>The right care and technology can make living your healthiest life convenient and accessible. {{sloganIn}} expands your virtual care options, allowing you to:</p>
                                          <ul>
                                                <li>Access care on your time, when you need it, 24/7. </li>
                                                <li>Connect with Member Services when you need support or have questions, 24/7.</li> 
                                                <li>Compare costs so you know exactly what you will pay. </li>
                                                <li>Save money with $0 out of pocket for virtual care options.*</li>
                                          </ul>
                                          <p class="font-disclaimer">*Benefits may vary. Please refer to your health plan documents for complete descriptions of benefits, exclusions, limitations, and conditions of coverage. $0 out of pocket applies to non-health savings account (HSA) plans. It applies to HSA plans after members have met their deductible.</p>
                                    </div>
                              </div>
                              <div class="grid-x grid-padding-x mb48">
                                    <div class="cell large-4">
                                          <img src="img/new-technology.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>New technology makes care more convenient</h3>
                                          <p>The list of health issues you can address through virtual care is expansive. You can take advantage of this trend with Link and the digital care tools that come with it, like our mobile app and online wellness resources.</p>
                                          <p>Link connects you with a carefully selected network of leading doctors and hospitals. There are expanded care options, so you don’t need to schedule health appointments weeks in advance. 
You can receive care when you need it, 24/7, from your smartphone. </p>
<p>If you prefer or need to see a doctor in person, you can do that with Link, too. You can feel confident you’re covered, even when you travel. </p>
                                          <p class="font-orange"> Check to see if your doctor is in the Link network. </p>
                                          <div class="grid-x grid-padding-x align-btn-center">
                                                <div class="cell small-8 medium-4">
                                                      <router-link to="/evaluation" class="button warning anthem-btn expanded">Check Now</router-link>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div class="grid-x grid-padding-x">
                                    <div class="cell large-4">
                                          <img src="img/check-status.jpg" width="300"/>
                                    </div>
                                    <div class="cell large-7">
                                          <h3>Check if {{sloganIn}} is right for you</h3>
                                          <p>Link could be the right fit if you:</p>
                                          <ul>
                                                <li>Stay on top of routine tests and screenings and find it valuable to do more routine care virtually.</li>
                                                <li>Prefer flexibility with your schedule so you can do things on your own time.</li>
                                                <li>Are comfortable using the latest technology. </li>
                                          </ul>
                                          <p>If you answered ‘yes’ to two or more of the above questions, Link may be a great fit for your health needs.</p>
                                          <p class="font-orange"> Talk to your employer about enrolling in {{sloganIn}}. </p>
                                          
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <section id="footer-copy" class="section">
                  <div class="grid-container">
                        <div class="grid-x gird-padding-x">
                              <div class="cell large-12">
                                    <p>1034850MUMENMUB BV 07/21</p>
                                    <p>Anthem Blue Cross is the trade name of Blue Cross of California. Independent licensee of the Blue Cross Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.</p>
                              </div>
                        </div>
                  </div>
            </section>
      </div>
</template>

<script>
      export default {
            name: "AnthemLinkHome",
            data(){
                  return{
                        sloganIn: 'Anthem Link',
                        title: "Anthem Link could<br class='break'/> be right for you",
                        content: "You know what matters most to you for your health. That is why we offer top-tier health care and a personalized member experience. Anthem Link could be a great choice for you and your family’s needs."
                  }
            },
            methods: {
                  openVideo(){
                        let message = '<div style="position: relative; display: block; max-width: 960px;"><div style="padding-top: 56.25%;"><iframe src="https://players.brightcove.net/3639471564001/default_default/index.html?videoId=6279080304001&autoplay=1" allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"  frameborder="0" allowfullscreen></iframe></div></div>'
                        this.$fire({
                              html: message,
                              showConfirmButton: false,
                              showCancelButton: false,  
                              showCloseButton: true,
                              width:'58em'
                        })
                        this.track('Watch Our Video')
                  },
                  track(label) {
                        this.$gtag.event('Click', {
                              'event_category': 'CTA',
                              'event_label': label,
                              'value': 1
                        })
                  }
            }
      }
</script>

<style lang="scss">
      .swal2-close{
            top:-14px !important;
            right:-14px !important;
            font-size: 1.5rem !important;
            color: #ffffff !important;
            background: #1779ba !important;
            line-height: 1.08 !important;
            border-radius: 50% !important;
            transition: all 0.2s ease-in-out 0s !important;
      }
      .swal2-close:hover{
            background: #1468a0 !important;
      }
      .font-disclaimer{
            font-size: 0.75rem !important;
      }
      .font-orange{
            font-size: 1.25rem !important;
            color: #f38021 !important;
            font-weight: 600;
      }
      .video-cta{
            display: none;
      }
      #home-content{
            position: relative;
            .section{
                  padding:120px 0px;
            }
            h1{
                  color:#0079c2;
                  font-weight: 600;
                  font-size: 3.25rem !important;
                  line-height: 3.25rem;
                  margin-bottom: 1.5rem !important;
                  span{
                        color:#012169;
                  }
            }
            p{
                  margin-bottom:1.125rem !important; 
                  font-size: 1.125rem;
            }
            .subtitle{
                  font-size: 1.45rem;
                  font-weight: 600;
            }
            .content{
                  margin-bottom: 3rem !important;
                  color:#012169;
                  font-weight: 600;
                  line-height: 1.6;
            }
            
            .anthem-btn {
                  color: #ffffff;
                  background-color: #0079c2 !important;
                  &:hover{
                        background-color: #126195 !important;
                  }
            }
            #home-hero{
                  padding-bottom: 60px;
                  /*position: relative;
                  background-size: 768px;
                  background-image: url("/img/family-anthem.png");
                  background-repeat: no-repeat;
                  background-position: right 39%;
                  .content-block{
                        position: absolute;
                        max-width: 560px;
                        top: 45%;
                        left: 15%;
                        transform: translateY(-50%);
                  }*/
                  .video-btn{
                        color:#0079c2; 
                        font-size: 1.5rem; 
                        font-weight: 600;
                        display: block;
                        position: relative;
                        &:before{
                              content:"";
                              position: absolute;
                              left: 50%;
                              top:50%;
                              border: 0;
                              background: transparent;
                              box-sizing: border-box;
                              border-color: transparent transparent transparent rgba(255,255,255,0.5);
                              transition: all 0.2s ease-in-out 0s;
                              cursor: pointer;
                              border-style: solid;
                              border-width: 27px 0 27px 45px;
                              z-index: 1;
                              transform: translate(-50%, -50%);
                        }
                        &:hover{
                              &:before{
                                    border-color: transparent transparent transparent rgba(255,255,255,0.8);
                              }
                        }
                  }
                  
            }
            #main-content{
                  position: relative;
                  padding-top:60px;
                  padding-bottom: 0px;
                  /*&:before{
                        content:"";
                        background-color: transparent;
                        position: absolute;
                        border-top: solid 4px #f38021;
                        border-right: solid 4px #f38021;
                        top: -20px;
                        left: 0;
                        bottom: 0px;
                        width: 92%;
                        z-index: 1;
                        border-radius: 0px 40px 0px 0px;
                        transform: skewY(2deg);
                  }*/
                  .grid-container{
                        max-width:90rem;
                  }
                  h2,h3{
                        color:#0079c2;
                  }
                  h2{
                        font-size: 3rem !important;
                        margin-bottom: 4rem !important;
                        position: relative;
                        z-index: 2;
                  }
                  h3{
                        font-size: 2rem !important;
                        margin-bottom: 1rem !important;
                  }
                  .main-content-features{
                        position: relative;
                        .grid-container{
                              background-color: #fefefe;
                              position: relative;
                              padding-top: 4rem;
                              padding-bottom: 5rem;
                              .cell{
                                    position: relative;
                                    z-index: 2;
                              }
                              /*&:before{
                                    content:"";
                                    background-color: #cde9f8;
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    bottom: 0;
                                    width: 83%;
                                    z-index: 0;
                                    border-radius: 72px 0px 0px 0px;
                              }*/
                        }
                        img{
                              position: relative;
                        }
                        /*&:before{
                              content:"";
                              background-color: #cde9f8;
                              position: absolute;
                              top: 0;
                              right: 0;
                              bottom: 0;
                              width: 50%;
                              z-index: 0;
                        }*/
                  }
                  
            }
            #footer{
                  background-color: #58b6e7;
                  position: relative;
                  z-index: 2;
                  .grid-container{
                        max-width:90rem;
                  }
                  &.section{
                        min-height: 400px; 
                        padding:60px 0px;
                  }
                  h2, p{
                        color:#ffffff;
                  }
                  h2{
                        font-size: 2.5rem !important;
                        font-weight: 600;
                        margin-bottom: 1.5rem !important;
                  }
                  p{
                        margin-bottom: 1.5rem !important;
                        font-weight: 600;
                  }
            }
            #footer-copy{
                  .grid-container{
                        max-width:90rem;
                  }
                  &.section{
                        min-height: 300px; 
                        padding:60px 0px;
                  }
                  p{
                        font-size: 0.75rem !important;
                        margin-bottom: 0px !important;
                        color:#666666;
                        &:first-child{
                              margin-bottom:1.125rem !important;
                        }
                  }
            }
            
      }
      @media only screen and (max-width:1542px){
            #home-content #home-hero .content-block{
                  left:3%;
            }
      }
      @media only screen and (max-width:1452px){
            
            #home-content #home-hero .content-block{
                  p.content{
                        font-size: 1.125rem;
                  }
            }
            #home-content .content{
                  margin-bottom: 2rem!important;
            }
            
            #main-content{
                  padding-top:20px !important;
            }
      }
      @media only screen and (max-width:1280px){
            .break{
                  display: none;
            }
            .video-btn{
                  margin:  0 auto;
                  span{
                        color: #ffffff;
                  }
            }
            #home-content #home-hero .content-block h1{
                  color: #ffffff;
                  font-size: 2rem !important;
                  line-height: 2.5rem !important;
                  text-align: center;
            }
            #home-content #home-hero .content-block p{
                  color: #ffffff;
            }
            #home-content #main-content:before{
                  display: none;
            }
            
      }
      @media only screen and (max-width:1023px){
            #home-hero{
                  padding-top:30px !important;
                  text-align: center;
            }
            .align-btn-center{
                  justify-content: center;
            }
            ul{
                  margin: 0 auto !important;
                  max-width: 450px !important;
                  text-align: left !important;
                  li{
                        margin-bottom: 16px;
                  }
            }
            .video-cta{
                  display: block;
            }
             .video-img-cta{
                  display: none;
            }
            .break{
                  display: none;
            }
            #home-content #main-content{
                  padding-top: 2rem !important;
            }
            #home-content #main-content h2 {
                  margin-bottom: 2rem !important;
            }
            #home-content #main-content .main-content-features .grid-container:before{
                  width:100%;
                  border-radius: 0px;
            }
            #home-content #main-content .main-content-features .grid-container .cell{
                  text-align: center;
            }
            #home-content #main-content .main-content-features img{
                  margin-bottom: 40px !important;
            }
            .swal2-popup{
                  background:none !important;
            }
            .swal2-close{
                  right:-8px !important;
            }
      }
      @media only screen and (max-width:640px){
            ul{
                  max-width: 350px !important;
            }
            #header .button.anthem-btn{
                  font-size: 0.87rem !important;
            }
            #home-content #home-hero {
                  min-height: 300px;
            }
             #home-content #home-hero .content-block p.content{
                 display: none;
            }
            #home-content .content-block .button.anthem-btn, 
            #home-content .content-block .button.hollow,
            #footer .button.anthem-btn{
                  font-size: 0.87rem !important;
            }
            #home-content #main-content h2 {
                  font-size: 2rem !important;
                  line-height: 2.5rem !important;
                  margin-bottom: 2rem !important;
            }
            #main-content{
                  padding-top:70px !important;
            }
            #home-content #footer.section{
                  min-height: 300px !important;
            }
            #home-content #footer h2 {
                  font-size: 2.2rem !important;
                  img{
                        width:15% !important;
                  }
            }
            #home-content #footer p {
                  margin-bottom: 1rem !important;
            }
      }
      @media only screen and (max-width:420px){
            #header .button.anthem-btn{
                  font-size: 0.83rem !important;
            }
      }
</style>
